import styled  from 'styled-components';

import { ShadeColorKeys } from '~src/styles/theme';

export const DialogTitle = styled.div<{ $color?: ShadeColorKeys; $fontColor?: ShadeColorKeys }>`
  font-size: 1.2rem;
  font-weight: normal;
  padding: 10px 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: ${({ $color, theme }) =>
    $color ? theme[$color].a10 : theme.red.a10};
  color: ${({ $fontColor, theme }) =>
    $fontColor ? theme[$fontColor].a10 : theme.white.a10};
`;

export const ColoredCloseContainer = styled.div<{ $fontColor?: ShadeColorKeys }>`
  .ant-modal-close-x {
    background: red;
    color: ${({ $fontColor, theme }) =>
      $fontColor ? theme[$fontColor].a10 : theme.white.a10};
  }
`;
